import React from 'react';
import { Heading } from './Heading';

export const SocialMedia = (props) => {
  const { subHeading, details } = props;
    return (
      <div className="contact-details__social-media social-media col-xs-12 col-md-4">
        <Heading content={ subHeading } size="h3" style={props.headingColor}/>
        <ul className="social-media__list list-unstyled">
          { details.map((elem, i) => {
            return (
              <li className="social-media__list-item" key={i}>
                <i className={`icon fa fa-${ elem.socialAccount }`} style={props.textColor}/>
                <span className="social-network"><a href={ elem.url } style={props.textColor} target="_blank">{ elem.username }</a></span>
              </li>
              )
            })}
        </ul>
      </div>
    );
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/SocialMedia.js